export default __webpack_public_path__ + "4d8cd881eec01a6bc8f48fe90aa08b50.svg";